<template>
    <div class="all-order">
        <div class="all-order-content">
       
            <template v-if="list && list.length" >
                <el-table :data="list" style="width: 100%" row-key="id" :stripe="true" border
                :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                :header-cell-style="{ background: '#fafafa', color: '#333' }">
      
                <el-table-column  type="index" label="序号" width="90" align="center" />
                <el-table-column prop="name" label="姓名"  align="center" />
                <el-table-column prop="idCardNo" label="身份证" align="center" />
                <el-table-column prop="gender" label="性别" align="center" />
                <el-table-column prop="phoneNumber" label="手机号" align="center" />
                <el-table-column prop="department" label="部门" align="center" />
                <el-table-column prop="jobTitle" label="职务" align="center" />
                <!-- <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="text" size="small" @click="editHandle(scope.row)">编辑</el-button>
                            <span class="u-split">|</span>
                            <el-popover :ref="`popover-${scope.$index}`" trigger="click" visible-arrow="false"
                                placement="top">
                                <p style="text-align: right; margin-bottom: 15px">您确定要删除吗？</p>
                                <div style="margin:0 auto;text-align: center;">
                                    <el-button size="mini" type="text"
                                        @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">取消</el-button>
                                    <el-button type="primary" size="mini" @click="delItem(scope.row);scope._self.$refs[`popover-${scope.$index}`].doClose()">确定</el-button>
                                </div>
                                <span slot="reference" style="color: #d9001b;cursor: pointer;;font-size: 12px;">删除
                                </span>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column> -->
            </el-table>
      </template>
        

            <div class="" v-else>
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：{{ timeValue }}，可提醒展商及时提交信息</p>
                </el-empty>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "all-order",
    props:{
        timeValue:String
    },
    data () {
        return {
            list: [],
            page: 1,
            size: 10,
            totalCount: 0,
          
        }
    },
    components: {
        // imgUpload,
    },
    computed: {
        ...mapGetters({
            exhibition: "loginModule/getExhibitionId",
        }),
        queryId () {
            return this.$route.query.id;
        },
    },
  

    mounted () {
        this.getList()
    },
    methods: {
        ...mapActions({
    
            getcardrecordList: 'exhibitionModule/getcardrecordList', //获取列表
         

        }),
        goDetail () {
            this.$router.push('/exhibition/index/order/detail-order');
        },
        async getList () {
            let opt = {
                id: this.queryId,
                ExhibitionId: this.exhibition,
                Page: this.page,
                Size: this.size,
            }
            let res = await this.getcardrecordList(opt)
            if (res) {
                console.log(res);
                this.list = res.items
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.all-order {
    min-width: 1000px;
    padding: 30px;
    min-height: 500px;

    &-content {
        background: #FFF;

        .goods {
            width: 18%;
            padding: 10% 0;
            display: inline-block;
            position: relative;
            margin: 0 3px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }
        }

        .goods-e {
            position: absolute;
            left: 100%;
            top: 30%;
            font-weight: bold;
        }

        .operation {
            color: #1890ff;
            cursor: pointer;
        }
    }
}
/deep/ .el-descriptions__body .el-descriptions__table{
    margin: 30px;
}
</style>